import * as actionTypes from '../types/support';

const initialState = {
  loading: false,
  success: false,
  processing: false,
  visible: false,
  error: false,
  number: null,
  data: {
    sysInfo: `${navigator.getBrowser} Разрешение окна: ${window.innerWidth}x${window.innerHeight}`
  },
  okPhoto: false,
  okSendEmail: false
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.OPEN_SUPPORT_WINDOW_SUCCESS:
      return {
        ...state,
        visible: true
      };
    case actionTypes.OPEN_SUPPORT_WINDOW_FAIL:
      return {
        ...state,
        visible: false
      };
    case actionTypes.CLOSE_SUPPORT_WINDOW:
      return {
        ...state,
        visible: false,
        data: {
          sysInfo: `${navigator.getBrowser} Разрешение окна: ${window.innerWidth}x${window.innerHeight}`
        }
      };
    case actionTypes.SET_SUPPORT_INFO:
      return {
        ...state,
        data: { ...state.data, ...payload },
        success: false
      };
    case actionTypes.GET_SUPPORT_NEXT_NUMBER:
      return {
        ...state,
        error: false,
        loading: true,
        number: null
      };
    case actionTypes.GET_SUPPORT_NEXT_NUMBER_SUCCESS:
      return {
        ...state,
        loading: false,
        number: payload
      };
    case actionTypes.GET_SUPPORT_NEXT_NUMBER_FAIL:
      return {
        ...state,
        error: true,
        loading: false
      };
    case actionTypes.SUPPORT_GET_LIST_PHOTOS_SUCCESS:
      return {
        ...state,
        listPhotos: payload,
        okPhoto: false
      };
    case actionTypes.SUPPORT_ADD_PHOTO_SUCCESS:
      return {
        ...state,
        okPhoto: true
      };

    case actionTypes.SUPPORT_SEND_EMAIL:
    case actionTypes.SUPPORT_SEND_EMAIL_FAIL:
      return {
        ...state,
        okSendEmail: false
      };
    case actionTypes.SUPPORT_SEND_EMAIL_SUCCESS:
      return {
        ...state,
        okSendEmail: true
      };
    case actionTypes.DEL_SUPPORT_NUMBER:
      return {
        ...state,
        number: null
      };

    default:
      return state;
  }
};

export default reducer;
